






import { Component, Vue, Prop} from "vue-property-decorator";

@Component({})

export default class EyeCloseIcon extends Vue {
  /* Props */
  @Prop({ default: "#FFFFFF" })
  public color!: string;
}
